import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { claimListService } from '../../../utilities/API/claimServices';
import moment from 'moment';

export const fetchClaimList = createAsyncThunk(
    'claimLists', claimListService
)

export const fetchAppClaimList = createAsyncThunk(
    'claimListsApp', claimListService
)

const initialState = {
    value: [],
    appClaims: [],
    loader: false
}

const claimListSlice = createSlice({
    name: 'claimList',
    initialState,
    reducers: {
        resetClaimList: (state, action) => {
            state.value = []
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchClaimList.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(fetchClaimList.fulfilled, (state, action) => {
                action?.payload.res.map((claim) => {
                    state.value.push({
                        program: action.payload.program,
                        claimID: claim.pyID,
                        applicationID: claim.ApplicationID,
                        patientName: claim.pxPages.PATTAB.pyFullName,
                        status: claim.pyStatusWork,
                        submissionDate: moment(claim.pxCreateDateTime).format('L'),
                        submittedAmount: claim.TotalAmountSubmitted == "0" ? "$0.00" : `$${Number(claim.TotalAmountSubmitted).toFixed(2)}`,
                        paidAmount: ((typeof claim?.TotalPaidAmount == "undefined" || claim?.TotalPaidAmount == "0") ? "$0.00" : `$${Number(claim.TotalPaidAmount).toFixed(2)}`),
                        checkNo: claim.CheckNumber || ""
                    })
                })
            })
            .addCase(fetchClaimList.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
            .addCase(fetchAppClaimList.pending, (state, action) => {
                state.loader = true
                state.appClaims = []
            })
            .addCase(fetchAppClaimList.fulfilled, (state, action) => {
                const arr = []
                action?.payload.res.map((claim) => {
                    arr.push({
                        program: action.payload.program,
                        claimID: claim.pyID,
                        applicationID: claim.ApplicationID,
                        patientName: claim.pxPages.PATTAB.pyFullName,
                        status: claim.pyStatusWork,
                        submissionDate: moment(claim.pxCreateDateTime).format('L'),
                        submittedAmount: claim.TotalAmountSubmitted == "0" ? "$0.00" : `$${Number(claim.TotalAmountSubmitted).toFixed(2)}`,
                        paidAmount: ((typeof claim?.TotalPaidAmount == "undefined" || claim?.TotalPaidAmount == "0") ? "$0.00" : `$${Number(claim.TotalPaidAmount).toFixed(2)}`),
                        checkNo: claim.CheckNumber || ""
                    })
                })
                state.appClaims = arr
                state.loader = false
            })
            .addCase(fetchAppClaimList.rejected, (state, action) => {
                state.loader = false
                state.appClaims = []
            })
    },
})

export const { resetClaimList } = claimListSlice.actions
export default claimListSlice.reducer